import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=25e6d1b2&scoped=true&"
import script from "./SurveyItem.vue?vue&type=script&lang=js&"
export * from "./SurveyItem.vue?vue&type=script&lang=js&"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&id=25e6d1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6d1b2",
  null
  
)

export default component.exports